module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.info.productName),
      expression: "info.productName"
    }]
  }, [_c('div', {
    staticClass: "product-head"
  }, [_c('span', {
    staticClass: "product-name pull-left"
  }, [_vm._v(_vm._s(_vm.info.productName) + "\n        "), (_vm.info.hasAutho == 1) ? _c('span', {
    staticClass: "is-bind-card"
  }, [_vm._v("(已绑定还款卡)")]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "time pull-left"
  }, [_vm._v("签约日期：" + _vm._s(_vm.info.signDate))])]), _vm._v(" "), _c('div', {
    staticClass: "order-table clearfix"
  }, [(_vm.info.borrowMoney) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("借款金额：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td"
  }, [_vm._v(_vm._s(_vm.info.borrowMoney) + "元")])]) : _vm._e(), _vm._v(" "), (_vm.info.interestRate) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("借款月利率：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td"
  }, [_vm._v(_vm._s(_vm.info.interestRate) + "%")])]) : _vm._e(), _vm._v(" "), (_vm.info.duration) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("借款期限：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td"
  }, [_vm._v(_vm._s(_vm.info.duration) + _vm._s(_vm.info.unit))])]) : _vm._e(), _vm._v(" "), (_vm.info.interest) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("借款利息：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td"
  }, [_vm._v(_vm._s(_vm.info.interest) + "元")])]) : _vm._e(), _vm._v(" "), (_vm.info.loanMoney) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("贷款金额：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td"
  }, [_vm._v(_vm._s(_vm.info.loanMoney) + "元")])]) : _vm._e(), _vm._v(" "), (_vm.info.loanBank) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("申贷银行：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td"
  }, [_vm._v(_vm._s(_vm.info.loanBank))])]) : _vm._e(), _vm._v(" "), (_vm.info.loanCardNo) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("放款卡号：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td"
  }, [_vm._v(_vm._s(_vm.info.loanCardNo))])]) : _vm._e(), _vm._v(" "), (_vm.info.loanCardName) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("放款卡户名：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td"
  }, [_vm._v(_vm._s(_vm.info.loanCardName))])]) : _vm._e(), _vm._v(" "), (_vm.info.loanCardBank) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("放款卡开户行：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td"
  }, [_vm._v(_vm._s(_vm.info.loanCardBank))])]) : _vm._e(), _vm._v(" "), (_vm.info.loanDate) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("放款日期：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td"
  }, [_vm._v(_vm._s(_vm.info.loanDate))])]) : _vm._e(), _vm._v(" "), (_vm.info.startRepaymentTime) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("预计还款时间：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td"
  }, [_vm._v(_vm._s(_vm.info.startRepaymentTime))])]) : _vm._e(), _vm._v(" "), (_vm.info.successRepaymentTime) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("实际还款时间：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td"
  }, [_vm._v(_vm._s(_vm.info.successRepaymentTime))])]) : _vm._e(), _vm._v(" "), (_vm.info.housePro) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("房屋属性：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td"
  }, [_vm._v(_vm._s(_vm.info.housePro))])]) : _vm._e(), _vm._v(" "), (_vm.info.houseAddr) ? _c('div', {
    staticClass: "order-tdbox"
  }, [_c('div', {
    staticClass: "order-td"
  }, [_vm._v("房屋地址：")]), _vm._v(" "), _c('div', {
    staticClass: "order-td",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.info.houseAddr))])]) : _vm._e()])]), _vm._v(" "), _c('Loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.info.productName),
      expression: "!info.productName"
    }],
    attrs: {
      "height": 400
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f831c7fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/order-detail.vue
// module id = 630
// module chunks = 1